(function(){
     'use strict';

     angular
        .module('appback')
        .factory('MaquinalisService', MaquinalisService);

    MaquinalisService.$inject = ['$http'];

    function MaquinalisService($http){

        var service= {
           guardarAlias:guardarAlias
        };

        return service;

        function guardarAlias(micro,alias,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               micro:micro,
               alias:alias
            });
            $http.post('/backend/maquinalis/guardaralias', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


      
    }
})();